import { useState } from "react";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";
import { WhatsAppIcon } from "./icons";
import { WHATSAPP_URL } from "@/lib/constants";

const NAV = [
  { label: "Cómo funciona", hash: "como-funciona", testid: "nav-link-como-funciona" },
  { label: "Por qué Nidoria", hash: "por-que-nidoria", testid: "nav-link-por-que" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const isHome = window.location.pathname === "/";
  const hrefFor = (hash) => (isHome ? `#${hash}` : `/#${hash}`);

  return (
    <header className="fixed inset-x-3 top-3 z-40 sm:inset-x-6" data-testid="site-header">
      <div className="mx-auto flex h-14 max-w-6xl items-center justify-between rounded-2xl border border-white/10 bg-[#12263a]/90 px-4 shadow-[0_16px_40px_-16px_rgba(6,20,34,0.7)] backdrop-blur-xl sm:px-5">
        <a href="/" aria-label="Nidoria — inicio" data-testid="header-logo-link">
          <Logo variant="light" />
        </a>

        <nav className="hidden items-center gap-7 md:flex" aria-label="Principal">
          {NAV.map((item) => (
            <a
              key={item.hash}
              href={hrefFor(item.hash)}
              data-testid={item.testid}
              className="text-sm font-semibold text-white/70 transition-colors duration-200 hover:text-[#14b8a6]"
            >
              {item.label}
            </a>
          ))}
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-whatsapp-button"
            className="inline-flex items-center gap-2 rounded-xl bg-[#25D366] px-4 py-2 text-sm font-bold text-[#06281a] transition-transform duration-200 hover:scale-[1.04] active:scale-95"
          >
            <WhatsAppIcon className="h-4 w-4" />
            WhatsApp Chat
          </a>
        </nav>

        <button
          className="inline-flex h-10 w-10 items-center justify-center rounded-xl text-white md:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-label={open ? "Cerrar menú" : "Abrir menú"}
          data-testid="mobile-menu-toggle"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {open && (
        <div className="mx-auto mt-2 max-w-6xl rounded-2xl border border-white/10 bg-[#12263a] px-4 pb-5 pt-3 shadow-2xl md:hidden" data-testid="mobile-menu">
          <div className="flex flex-col gap-1">
            {NAV.map((item) => (
              <a
                key={item.hash}
                href={hrefFor(item.hash)}
                onClick={() => setOpen(false)}
                data-testid={`mobile-${item.testid}`}
                className="rounded-xl px-3 py-3 text-sm font-semibold text-white/85 transition-colors duration-200 hover:bg-white/5 hover:text-[#14b8a6]"
              >
                {item.label}
              </a>
            ))}
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="mobile-whatsapp-button"
              className="mt-2 inline-flex items-center justify-center gap-2 rounded-xl bg-[#25D366] px-4 py-3 text-sm font-bold text-[#06281a]"
            >
              <WhatsAppIcon className="h-4 w-4" />
              WhatsApp Chat
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
